/**
 * Overlay chart stay fields onto the patient record for UI display.
 * Identity (name, DOB, …) stays patient-level; status/dates follow the chart.
 */

export function patientWithChartContext(patient, episodeMeta) {
  if (!patient) return patient;
  const chart = episodeMeta?.chart;
  if (!chart) return patient;
  return {
    ...patient,
    status: chart.status || patient.status,
    admissionDate: chart.startDate ?? patient.admissionDate,
    dischargeDate: chart.dischargeDate ?? patient.dischargeDate,
    _chartId: chart.id,
    _chartNumber: chart.chartNumber,
  };
}

export default patientWithChartContext;
